import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import * as Constants from '../../config/Constants'
import getText from './i18n/labels'

import { registerLocale } from 'react-datepicker'
import it from 'date-fns/locale/it'
import en from 'date-fns/locale/en-US'

import { RadioButtonSelected, RadioButtonUnselected } from '../shared/RadioButton'

export function PersonTypeField(props) {
  const lang = useSelector((state) => state.language.language)
  const labels = getText(lang)

  registerLocale(lang, lang === 'it' ? it : en)

  const [personType, setPersonType] = useState(props.personType)
  const [error, setError] = useState({ isValid: true, msg: '' })

  useEffect(() => {
    setPersonType(props.personType)
  }, [props.personType])

  useEffect(() => {
    if (props.error !== undefined && props.error !== error) {
      setError(props.error)
    } else {
      setError({ isValid: true, msg: '' })
    }
  }, [props.error])

  return (
    <>
      <div className="form-check mb-3">
        <label>{labels.TYPE}</label>
        <div className="input-group mt-2 d-flex flex-column">
          <div className="inputRadio mt-1 mb-4 ">
            <input
              hidden={true}
              className="form-check-input"
              type="radio"
              name={`personType${props.id}`}
              id={`personType1${props.id}`}
              value={Constants.PNF}
              onClick={props.onClick}
              disabled={props.readOnly}
            />
            <label className="form-check-label" htmlFor={`personType1${props.id}`}>
              {personType === Constants.PNF ? <RadioButtonSelected /> : <RadioButtonUnselected />}
              {labels.LEGAL_PERSON}
            </label>
          </div>
          <div className="inputRadio">
            <input
              hidden={true}
              className="form-check-input"
              type="radio"
              name={`personType${props.id}`}
              id={`personType2${props.id}`}
              value={Constants.PF}
              onClick={props.onClick}
              disabled={props.readOnly}
            />
            <label className="form-check-label" htmlFor={`personType2${props.id}`}>
              {personType === Constants.PF ? <RadioButtonSelected /> : <RadioButtonUnselected />}
              {labels.PHYSICAL_PERSON}
            </label>
          </div>
        </div>
        {!error.isValid && <div className="text-danger">{error.msg}</div>}
      </div>
    </>
  )
}
